import { CircularProgress } from '@mui/material'
import { FlexRow } from '@xylabs/sdk-react'
import { useContext } from 'react'

import { Erc721MetaDataContext } from '../../Contexts'
import { Property } from '../Property'

const ImageProperty: React.FC = () => {
  const { image_data } = useContext(Erc721MetaDataContext)
  return (
    <Property title="Image" value="Image">
      <FlexRow
        paper
        sx={{ display: { md: 'flex', xs: 'none' } }}
        alignItems="center"
        display="flex"
        height={256}
        justifyContent="center"
        width={256}
        margin={1}
      >
        {image_data ? <img alt="Geotoken" height={256} src={`data:image/svg+xml;utf8,${image_data}`} width={256} /> : <CircularProgress size={24} />}
      </FlexRow>
      <FlexRow paper sx={{ display: { sm: 'none' } }} alignItems="center" display="flex" height={128} justifyContent="center" width={128} margin={1}>
        {image_data ? <img alt="Geotoken" height={128} src={`data:image/svg+xml;utf8,${image_data}`} width={128} /> : <CircularProgress size={24} />}
      </FlexRow>
    </Property>
  )
}

export default ImageProperty
